import { cn } from '@/lib/utils'
import { HelpCircleIcon } from 'lucide-react'
import React from 'react'
import ButtonBase from './Button/ButtonBase'
import {
    Popover,
    PopoverAnchor,
    PopoverContent,
    PopoverTrigger,
} from './ui/popover'

interface IProps {
    children?: React.ReactNode
    size?: 'small' | 'medium' | 'large'
    Icon?: React.ReactElement
    /** className passado para o popover trigger */
    className?: string
}

export default function IconeAjuda({
    children,
    size,
    Icon,
    className,
}: IProps) {
    const sizeClass =
        size === 'small'
            ? '[&_svg]:size-4 p-1.5'
            : size === 'large'
              ? '[&_svg]:size-8 p-3'
              : '[&_svg]:size-6 p-2'

    Icon ??= <HelpCircleIcon />

    const [open, setOpen] = React.useState(false)

    function handleOpenChange() {
        setTimeout(() => {
            setOpen(!open)
        }, 150)
    }

    return (
        <Popover open={open} onOpenChange={handleOpenChange}>
            <PopoverTrigger asChild>
                <PopoverAnchor className="group-aria-disabled:pointer-events-none">
                    <ButtonBase
                        variant="ghost"
                        size="icon"
                        className={cn(
                            sizeClass,
                            'rounded-full text-inherit hover:text-inherit size-fit',
                            className,
                        )}
                    >
                        {Icon}
                    </ButtonBase>
                </PopoverAnchor>
            </PopoverTrigger>

            <PopoverContent className="text-left">{children}</PopoverContent>
        </Popover>
    )
}
